import axios from '../../../../../redux/my-axios';

export const SALES_URL = '/sales';

export function findSales(queryParams) {
  return axios.post(SALES_URL, queryParams, { headers: { action: 'find' } });
}

export function getSale(saleCode) {
  return axios.post(SALES_URL, saleCode, { headers: { action: 'get' } });
}

export function createSale(sale) {
  return axios.post(SALES_URL, sale, { headers: { action: 'post' } });
}
export function updateSale(saleForView) {
  return axios.post(SALES_URL, saleForView, { headers: { action: 'put' } });
}

export function deleteSale(saleCode) {
  return axios.post(SALES_URL, saleCode, { headers: { action: 'delete' } });
}

export function closeOrder(saleCode) {
  return axios.post(SALES_URL, saleCode, { headers: { action: 'closeorder' } });
}
